<style scoped>
  .title{font-size: 16px;color: #00a2e9;display: inline-block;line-height: 66px;padding: 0 24px;}
  .title div{width: 4px;height: 18px;background-color: #00a2e9;display: inline-block;margin-right: 5px;vertical-align: text-bottom;}
  .time{display: inline-block;float: right;line-height: 66px;padding: 0 24px;}
  .financial >>> .ivu-input{border-radius: 18px;}
  .btn-default{font-size: 14px;color: #00a2e9;display: inline-block;vertical-align:middle}
  .search >>> .ivu-input{width: 280px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .search-button{background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 17px;text-align: center;right: 6px;cursor:pointer;}
  .list-panel{background-color: white;padding:0 40px}
  .notice-background{background: url("/img/sys/bg5.png");height: 140px;}
  .project-class{text-align: center;font-size: 14px;color: #333333;height: 62px;border-bottom: 1px solid #d7dde4;line-height: 62px;background-color: #fff;}
</style>

<template>
  <div class="project">
    <Row style="margin-bottom:15px">
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row :gutter="40">
      <!--我的案件数-->
        <Col span="16" style="margin-bottom: 40px;">
          <div style="background-color: #fff;padding: 0;">
            <div class="title">
              <div class="inline-block"></div>
              <p style="display: inline-block;vertical-align: top;">我的案件数</p>
            </div>
            <Col span="24" style="text-align: center;background-color: #fff;">
              <!--for-->
              <Col span="8" style="margin: 0 0 20px 0;" v-for="i in 3">
                <p style="color: #f64b4b;font-size: 24px;">26</p>
                <p style="color: #464c5b;font-size: 14px;">今日统计</p>
              </Col>
            </Col>
          </div>
        </Col>
      <!--办案冠军-->
      <Col span="8" style="margin-bottom: 40px;">
        <div style="background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">我的任务数</p>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;">
            <Col span="8" style="margin: 0 0 20px 0;" v-for="i in 3">123</Col>
          </Col>
        </div>
      </Col>
        <!--我的任务数-->
        <Col span="16" style="margin-bottom: 40px;">
          <div style="background-color: #fff;padding: 0;">
            <div class="title">
              <div class="inline-block"></div>
              <p style="display: inline-block;vertical-align: top;">我的任务数</p>
            </div>
            <Col span="24" style="text-align: center;background-color: #fff;">
              <!--for-->
              <Col span="8" style="margin: 0 0 20px 0;" v-for="i in 3">
                <p style="color: #f64b4b;font-size: 24px;">26</p>
                <p style="color: #464c5b;font-size: 14px;">今日统计</p>
              </Col>
            </Col>
          </div>
        </Col>
    </Row>
    <!--数据查询-->
    <Row>
      <Col span="24">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">数据查询</p>
          </div>
          <div style="float: right;display: inline-block;line-height: 66px;margin-right: 40px;">
            <img style="margin: 0 10px;vertical-align:middle" src="/img/project/screen-icon.png"/>
            <p style="color: #6c767a" class="btn-default">筛选</p>
          </div>
        </div>
      </Col>
      <Col span="24">
        <Menu mode="horizontal" style="padding:0 40px" active-name="1">
          <MenuItem name="1">
            我负责的案件
          </MenuItem>
          <MenuItem name="2">
            我参与的案件
          </MenuItem>
          <MenuItem name="3">
            抄送我的案件
          </MenuItem>
          <div style="position: relative;display: inline-block;margin-left: 12px;float: right;">
            <Input class="search"  placeholder="输入客户名" ></Input>
            <div class="search-button">
              <img style="margin-top: 6px;vertical-align: top;" src="/img/project/search-icon.png"/>
            </div>
          </div>
        </Menu>
        <!---->
        <div class="list-panel">
          <Row style="text-align: center;">
            <Col span="24"  class="project-class" style="font-weight: bold;">
              <Col span="8">项目名</Col>
              <Col span="4">最新进展</Col>
              <Col span="4">时间</Col>
              <Col span="4">状态</Col>
              <Col span="4">待处理任务</Col>
            </Col>
            <Col span="24" class="project-class" v-for="i in 5" style="height: 95px;line-height: 95px;">
              <Col span="8">项目名称项目名称项目名称项目名称项目名称</Col>
              <Col span="4">进展情况xxx</Col>
              <Col span="4">2018.04.08</Col>
              <Col span="4">在办</Col>
              <Col span="4">9/34</Col>
            </Col>
          </Row>
          <Row>
            <Col span="24" style="margin:40px 0 57px 0;">
              <Page :total="100" show-elevator />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "project",//项目统计
    data(){
      return{
        taskData : [
          {name : '我负责的案件'},
          {name : '我参与的案件'},
          {name : '抄送我的案件'},
        ],
        defaultdata : 0,
      }
    },
  }
</script>

